/* Contact form, fetch submit (no page reload). Added by Oleg @ IAKOE.
   Progressive enhancement over the native {% form 'contact' %}: without JS the
   classic reload flow still works. The POST goes to the same /contact endpoint
   with the same fields; the redirected response HTML is parsed for this
   section's error block. No errors = success: the form hides and the success
   line (data-success) appears in its place. A bot-challenge page, a non-OK
   response or a network error falls back to a NATIVE submit so Shopify's
   captcha flow can run (form.submit() does not re-fire this handler). */
class TsCform extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.pending = false;
    this.form.addEventListener('submit', (e) => this.onSubmit(e));
  }

  async onSubmit(e) {
    e.preventDefault();
    if (this.pending || !this.form.reportValidity()) return;
    this.pending = true;
    const btn = this.form.querySelector('[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }
    try {
      const res = await fetch(this.form.action, {
        method: 'POST',
        body: new FormData(this.form),
        headers: { Accept: 'text/html' },
      });
      const finalPath = new URL(res.url, location.href).pathname;
      if (!res.ok || finalPath.includes('/challenge')) {
        this.form.submit();
        return;
      }
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const scope = doc.getElementById('shopify-section-' + this.dataset.sectionId) || doc;
      const errors = scope.querySelector('.ts-cform__errors');
      this.querySelectorAll('.ts-cform__errors, .ts-cform__success').forEach((n) => n.remove());
      if (errors) {
        this.form.prepend(errors);
        this.reveal(errors);
      } else {
        const msg = document.createElement('p');
        msg.className = 'ts-cform__success ia-font-body ia-uppercase';
        msg.setAttribute('role', 'status');
        msg.textContent = this.dataset.success || 'Thanks! We will be in touch soon.';
        this.form.hidden = true;
        this.form.insertAdjacentElement('beforebegin', msg);
        this.reveal(msg);
      }
    } catch (err) {
      this.form.submit();
    } finally {
      this.pending = false;
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    }
  }

  reveal(el) {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  }
}

if (!customElements.get('ts-cform')) customElements.define('ts-cform', TsCform);
